export default {
  "ui:order": ["caller_gender", "caller_age", "caller_environment",
            "receiver_gender", "receiver_age", "receiver_environment"],
  "required": ["caller_gender", "caller_age", "caller_environment",
            "receiver_gender", "receiver_age", "receiver_environment"],
  "ui:readonly": ["caller_speakerid", "receiver_speakerid"],
  "properties": {
    "caller_props": {
      "properties": {
        "caller_carrier": {
          "title": "Carrier",
          "required": false,
          "admin_fixed": true,
          "enumNames": ["SwiftNet", "BritishTelecom", "VoiceFlex"],
          "enum": ["SwiftNet", "BritishTelecom", "VoiceFlex"],
          "user": "caller",
          "disableType": 2,
          "order": 0,
          "mirror": true,
        },
        "caller_country_code": {
          "title": "Country Code",
          "required": false,
          "admin_fixed": true,
          "enumNames": [""],
          "disableType": 2,
          "enum": [""],
          "user": "caller",
          "order": 1,
          "mirror": false,
        },
        "caller_number": {
          "title": "Number",
          "required": true,
          "admin_fixed": true,
          "disableType": 4,
          "type": "string",
          "user": "caller",
          "minLength": 4,
          "maxLength": 15,
          "order": 2,
          "mirror": false,
        },
        "caller_speakerid": {
          "title": "Speaker ID",
          "required": true,
          "admin_fixed": false,
          "disableType": 1,
          "type": "number",
          "user": "caller",
          "order": 3,
          "readonly": true,
          "htmlClass": "hidden",
          "style": "display: none;",
          "mirror": false,
        },
        "caller_age": {
          "title": "Age",
          "required": true,
          "type": "string",
          "user": "caller",
          "minLength": 18,
          "maxLength": 75,
          "order": 4,
          "mirror": false,
        },
        "caller_gender": {
          "title": "Gender",
          "required": true,
          "type": "string",
          "user": "caller",
          "order": 5,
          "enumNames": ["Male", "Female"],
          "enum": [3, 4],
          "mirror": false,
        },
        "caller_environment": {
          "title": "Environment",
          "required": true,
          "type": "string",
          "user": "caller",
          "order": 6,
          "minLength": 1,
          "maxLength": 1,
          "mirror": false,
        }
      },
      "title": "Caller",
      "type": "object"
    },
    "receiver_props": {
      "properties": {
        "receiver_carrier": {
          "title": "Carrier",
          "required": false,
          "admin_fixed": true,
          "enumNames": ["SwiftNet", "BritishTelecom", "VoiceFlex"],
          "enum": ["SwiftNet", "BritishTelecom", "VoiceFlex"],
          "disableType": 2,
          "user": "receiver",
          "order": 6,
          "mirror": true,
        },
        "receiver_country_code": {
          "title": "Country Code",
          "required": false,
          "admin_fixed": true,
          "enumNames": [""],
          "enum": [""],
          "user": "receiver",
          "disableType": 2,
          "order": 7,
          "mirror": false,
        },
        "receiver_number": {
          "title": "Number",
          "required": true,
          "admin_fixed": true,
          "disableType": 4,
          "type": "string",
          "user": "receiver",
          "minLength": 4,
          "maxLength": 15,
          "order": 8,
          "mirror": false,
        },
        "receiver_speakerid": {
          "title": "Speaker ID",
          "required": true,
          "admin_fixed": false,
          "disableType": 1,
          "type": "number",
          "user": "receiver",
          "order": 9,
          "readonly": true,
          "htmlClass": "hidden",
          "style": "display: none;",
          "mirror": false,
        },
        "receiver_age": {
          "title": "Age",
          "required": true,
          "type": "string",
          "user": "receiver",
          "minLength": 18,
          "maxLength": 75,
          "order": 10,
          "mirror": false,
        },
        "receiver_gender": {
          "title": "Gender",
          "required": true,
          "type": "string",
          "user": "receiver",
          "order": 11,
          "enumNames": ["Male", "Female"],
          "enum": [3, 4],
          "mirror": false,
        },
        "receiver_environment": {
          "title": "Environment",
          "required": true,
          "type": "string",
          "user": "receiver",
          "minLength": 1,
          "maxLength": 1,
          "order": 12,
          "mirror": false,
        }
      },
      "title": "Caller",
      "type": "object"
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/projectconfig/constant.js